module.exports = __webpack_public_path__ + "static/CLASSROOM1-7c0e928817f4b93e31153b0844c337d5.jpg";